"use client";
import React, { useState, useEffect } from "react";
import Navbar from "../../../../components/navbar";
import Footer from "../../../../components/footer";
import FilterSearch from "../../../../components/FilterSearch(name)";
import FilterTabs from "../../../../components/universal-filter-tabs";
import Status from "../../../../components/Status";
import FormInput from "../../../../components/FormInput";
import Button from "../../../../components/Button";
import Pagination from "../../../../components/Pagination";
import styles from "../css/totalOutstanding.module.css";
import FollowUpSignatureFlow from "./FollowUpSignatureFlow.jsx";
import { fetchTotalOutstandingToFollows } from "../../../../api/toFollows/toFollowsApi.js";
import { useAuth } from "../../../../context/AuthContext";

export default function TotalOutStanding({ asModal = false, profileNo = null, onDispensed }) {
  const { user } = useAuth();
  const [search, setSearch] = useState("");
  const [active, setActive] = useState("All");
  const [page, setPage] = useState(1);
  const [showSignatureFlow, setShowSignatureFlow] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const buttons = ["Ready", "Pending", "All"];

  useEffect(() => {
    let isMounted = true;
    setLoading(true);
    setError(null);
    setPage(1);
    (async () => {
      try {
        const data = await fetchTotalOutstandingToFollows(profileNo, user?.branchcode);
        if (isMounted) {
          setItems(data);
        }
      } catch (err) {
        if (isMounted) {
          setError(err.message || "Failed to load to-follows");
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    })();
    return () => {
      isMounted = false;
    };
  }, [profileNo, user?.branchcode]);

  const filtered = items.filter((p) => {
    const patientName = (p.firstName || p.name || "").toLowerCase();
    const matchesSearch = patientName.includes(search.toLowerCase());
    const matchesTab =
      active === "All" ||
      (active === "Ready" && p.status.toLowerCase().includes("ready")) ||
      (active === "Pending" && p.status.toLowerCase().includes("pending"));
    return matchesSearch && matchesTab;
  });

  const pageSize = 2;
  const totalPages = Math.max(1, Math.ceil(filtered.length / pageSize));
  const startIndex = (page - 1) * pageSize;
  const pageItems = filtered.slice(startIndex, startIndex + pageSize);

  return (
    <div className={styles.container}>
      {!asModal && <Navbar />}
      <main className={styles.main}>
        {!asModal && (
          <div className={styles.filterBar}>
            <FilterSearch
              filterName="Filter"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search Name"
            />
          </div>
        )}

        <div className={styles.tabsWrapper}>
          <FilterTabs
            buttons={buttons}
            activeButton={active}
            onButtonClick={setActive}
          />
        </div>

        {error && (
          <div className={styles.error}>{error}</div>
        )}
        <div className={styles.cardsGrid}>
          {!loading && pageItems.map((p, i) => {
            const displayProfile = asModal && profileNo != null ? profileNo : p.profile;
            return (
              <div className={styles.card} key={i}>
                <div className={styles.cardHeader}>
                  <div className={styles.patientInfo}>
                    <div className={styles.avatar}>g</div>
                    <div>
                      <div className={styles.name}>{p.name}</div>
                      <div className={styles.subtle}>Profile Number: {displayProfile}</div>
                    </div>
                  </div>
                  <Status status={p.status} />
                </div>
              <div className={styles.formGrid}>
                <FormInput label="Medication" value={p.medication} name={`med-${i}`} />
                <FormInput label="Strength" value={p.strength} name={`str-${i}`} />
                <FormInput label="Quantity Owed" value={p.owed} name={`owed-${i}`} />
                <FormInput label="Already Dispensed" value={p.dispensed} name={`disp-${i}`} />
                <FormInput label="Prescription #" value={p.rx} name={`rx-${i}`} />
                <FormInput label="Created" value={p.created} name={`created-${i}`} />
              </div>
              <div className={styles.buttonBar}>
                <Button
                  className={styles.actionBtn}
                  variant="primary"
                  onClick={() => {
                    setSelectedItem(p);
                    setShowSignatureFlow(true);
                  }}
                >
                  Complete Follow Up
                </Button>
              </div>
            </div>
          );
          })}
        </div>

        <div className={styles.paginationWrapper}>
          <Pagination currentPage={page} totalPages={totalPages} onPageChange={setPage} />
        </div>
      </main>
      {!asModal && <Footer />}
      <FollowUpSignatureFlow
        isOpen={showSignatureFlow}
        onClose={() => {
          setShowSignatureFlow(false);
          setSelectedItem(null);
        }}
        item={selectedItem}
        onDispensed={(id) => {
          if (id == null) return;
          setItems((prev) => prev.filter((it) => it.id !== id));
          if (typeof onDispensed === "function") {
            onDispensed(id);
          }
        }}
      />
    </div>
  );
}


